import React from 'react'

const DetailsCell = ({ details }) => {
  return <div> {details} </div>
}

export default DetailsCell
